import script from "./welfareTreasureRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./welfareTreasureRecord.vue?vue&type=script&setup=true&lang=js"

import "./welfareTreasureRecord.vue?vue&type=style&index=0&id=2f1002dc&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f1002dc"]])

export default __exports__